import React from 'react';
import '../styling/Footer.css';

function Footer() {
  return (
    <footer className="footer-section">
      <div className="footer-links">
        <a href="/terms" target="_blank" rel="noopener noreferrer">Terms of Service</a>
        <a href="/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
        <a href="/support" target="_blank" rel="noopener noreferrer">Support</a>
      </div>
      <p>&copy; {new Date().getFullYear()} Kyro Studios. All rights reserved.</p>
    </footer>
  );
}

export default Footer;
